// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RXTn","newExpiryDate":"styles_newExpiryDate__1wvbi","footer":"styles_footer__bvp9H"};